import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer>
      <div className="footer-sec">
        <div className="container-fluid add-padding">
          <div className="row justify-content-center">
            <div className="col-xl-6 col-lg-7 col-md-8 col-sm-11 col-12">
              <div className="footer-newsletter">
                <h2>Stay Inspired – Sign Up Today</h2>
                <form id="newsletterForm">
                  <input
                    type="email"
                    name="newsletter[newsletter_email]"
                    placeholder="Email Address"
                  />
                  <div className="footer-latest-update-btn">
                    <button type="submit">
                      <i className="fa-solid fa-paper-plane"></i>
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>

          <div className="row custom-border">
            {/* Quick Links */}
            <div className="col-lg-3 col-md-3 col-12">
              <div className="footer-support">
                <h2>Quick Links</h2>
                <ul>
                  <li><Link to="/">Home</Link></li>
                  <li><Link to="/about">About Us</Link></li>
                  <li><Link to="/services">Services</Link></li>
                  <li><Link to="/projects">Gallery</Link></li>
                  <li><Link to="/blog">Blogs</Link></li>
                  <li><Link to="/contact">Contact Us</Link></li>
                  <li><Link to="/enquire">Enquire</Link></li>
                </ul>
              </div>
            </div>

            {/* Logo & Social */}
            <div className="col-lg-6 col-md-6 col-12">
              <div className="footer-logo">
                <Link to="/">
                  <img
                    src="/images/footer_logo176071690649.png"
                    alt="The Design Showroom by LUXE"
                  />
                </Link>
                <p>
                  At The Design Showroom, we believe great design begins with
                  imagination and is brought to life through intention.
                </p>
                <ul className="footer-social">
                  <li><a href="#"><i className="fab fa-facebook-f"></i></a></li>
                  <li><a href="#"><i className="fab fa-linkedin-in"></i></a></li>
                  <li><a href="#"><i className="fab fa-x-twitter"></i></a></li>
                  <li><a href="#"><i className="fab fa-instagram"></i></a></li>
                </ul>
              </div>
            </div>
            <div className="col-lg-3 col-md-3 col-12">
              <div className="footer-latest-update">
                <h2>Contact Info</h2>
                <ul>
                  <li>
                    <a
                      href="https://www.google.com/maps"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fa-solid fa-location-dot"></i>{" "}
                      <span>
                        225-226 High Street St, Brentford, Middlesex, TW8 0JS
                      </span>
                    </a>
                  </li>
                  <li>
                    <a href="mailto:sales@thedesignshowroom.com">
                      <i className="fa-solid fa-envelope"></i>
                      <span>sales@thedesignshowroom.com</span>
                    </a>
                  </li>
                  <li>
                    <a href="tel:02031960378">
                      <i className="fa-solid fa-phone"></i>
                      <span>02031960378</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="container-fluid add-padding">
          <div className="footer-copy-right-sec">
            <div className="row">
              <div className="col-lg-6 col-md-7 col-12">
                <p className="wow fadeInDown" data-wow-duration="2s" style={{ textAlign: 'left' }}>© 2025 The Design Showroom. All RightsReserved.</p>
              </div>
              <div className="col-lg-6 col-md-5 col-12">
                <ul className="ftr-lnks">
                  <li><Link to="/terms_and_conditions">Terms &amp; Conditions</Link></li>
                  <li><Link to="/cookie_policy">Cookies Policy</Link></li>
                  <li><Link to="/gdpr_policy"> GDPR Policy</Link></li>
                </ul>
              </div>
            </div>
          </div>
        </div>

      </div>
    </footer>
  );
};

export default Footer;
